// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__20zKi","box":"WorkspacesBox_box__3Kfb9","node":"WorkspacesBox_node__2Ar1b"};